import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import { optimizeImageUrl } from '../lib/prismicImage';

const ThumbnailImg = styled.div`
  width: 100%;
  height: 100%;
  background-image: url(${props => props.src});
  background-size: cover;
  background-position: center;
  transition: transform 0.3s ease;
`;

const ThumbnailPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-muted);
`;

const Title = styled.h3`
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--compact-title);
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.4;
  transition: color 0.2s;
`;

const CardLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem;
  border-bottom: 1px solid var(--border);
  text-decoration: none;
  background: var(--card-bg);
  transition: background 0.15s;
  &:last-child { border-bottom: none; }
  &:hover { background: var(--hover-bg); }
  &:hover ${ThumbnailImg} { transform: scale(1.08); }
  &:hover ${Title} { color: var(--compact-title-hover); }
`;

const Thumbnail = styled.div`
  flex-shrink: 0;
  width: 5rem;
  height: 4rem;
  border-radius: 0.375rem;
  overflow: hidden;
  background: var(--bg-tertiary);
  @media (min-width: 640px) {
    width: 6rem;
    height: 4.5rem;
  }
`;

const Content = styled.div`
  flex: 1;
  min-width: 0;
`;

const CompactCard = ({ title, img, uid }) => {
  const href = uid && uid.startsWith('/') ? uid : `/${uid}/`;
  return (
    <CardLink to={href}>
      <Thumbnail>
        {img ? (
          <ThumbnailImg src={optimizeImageUrl(img, 200)} />
        ) : (
          <ThumbnailPlaceholder>
            <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
          </ThumbnailPlaceholder>
        )}
      </Thumbnail>
      <Content>
        <Title>{title}</Title>
      </Content>
    </CardLink>
  );
};

export default CompactCard;
